import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { LoggedOutHomeImage } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/LoggedOutHomeImage/LoggedOutHomeImage";
import * as componentStyles from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BrandValueBanner/__internal__/styles.css";
import { DESKTOP_BANNER_HEIGHT, MOBILE_BANNER_HEIGHT, TABLET_BANNER_HEIGHT, XL_DESKTOP_BANNER_HEIGHT } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BrandValueBanner/__internal__/styles.css";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import classNames from "classnames";
import React from "react";
export var BrandValueBannerBrandInfo = function(param) {
    var brandInfo = param.brandInfo, className = param.className;
    if (!brandInfo) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Flex, {
        align: {
            mobileAndAbove: "flex-start",
            desktopAndAbove: "center"
        },
        direction: {
            mobileAndAbove: "column",
            tabletAndAbove: "row"
        },
        className: classNames(componentStyles.brandInfo, className),
        gap: {
            mobileAndAbove: "4x",
            tabletAndAbove: "6x"
        },
        children: [
            /*#__PURE__*/ _jsx(LoggedOutHomeImage, {
                lazyLoad: true,
                className: classNames("w-full md:w-1/2", componentStyles.image),
                responsiveImage: {
                    mobileAndAbove: IImage.build({
                        url: brandInfo.image
                    })
                },
                optimizeImageOptions: {
                    mobileAndAbove: {
                        width: MOBILE_BANNER_HEIGHT,
                        height: MOBILE_BANNER_HEIGHT
                    },
                    tabletAndAbove: {
                        width: TABLET_BANNER_HEIGHT,
                        height: TABLET_BANNER_HEIGHT
                    },
                    desktopAndAbove: {
                        width: DESKTOP_BANNER_HEIGHT,
                        height: DESKTOP_BANNER_HEIGHT
                    },
                    xLargeAndAbove: {
                        width: XL_DESKTOP_BANNER_HEIGHT,
                        height: XL_DESKTOP_BANNER_HEIGHT
                    }
                }
            }),
            /*#__PURE__*/ _jsx(RightColumn, {
                brandInfo: brandInfo
            })
        ]
    });
};
var RightColumn = function(param) {
    var brandInfo = param.brandInfo;
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var name = brandInfo.name, location = brandInfo.location, description = brandInfo.description, cta = brandInfo.cta;
    return /*#__PURE__*/ _jsxs(Column, {
        justify: "center",
        className: "w-full md:w-1/2",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "sectionHeaderSansMedium",
                children: name
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                children: location
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                className: componentStyles.content,
                children: description
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "secondary",
                style: {
                    width: "fit-content"
                },
                linkTo: cta.link,
                className: "hover:!bg-core-surface-default !bg-transparent",
                onClick: function() {
                    trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("brand_value_banner-cta", cta.link, "".concat(homepageRedesignVariant));
                },
                children: cta.name
            })
        ]
    });
};
